const getUrl = window.location.origin
let env = ''
let bbUrl = ''
let graphUrl = ''
if (process.env.NODE_ENV === 'development') {
  bbUrl = 'https://bdo-dac6-dev.bettywebblocks.com/api/'
  graphUrl = 'https://bdo-dac6-dev.betty.app/api/runtime/f266633005d74c9bb3ccb4838a8d2806'
} else {
  bbUrl = getUrl + '/api/'
  const subdomain = getUrl.split('.')[0]
  // Sandbox logic
  if (subdomain.endsWith('dev')) {
    graphUrl = subdomain + '.betty.app/api/runtime/f266633005d74c9bb3ccb4838a8d2806'
  } else if (subdomain.endsWith('test')) {
    graphUrl = subdomain + '.betty.app/api/runtime/ef377cab0c8b4f61aa8dc789a6a955e4'
  } else if (subdomain.endsWith('acc')) {
    graphUrl = subdomain + '.betty.app/api/runtime/b0c98e61ec6244a5b666e2c53bfa5a90'
  } else {
    graphUrl = subdomain + '.betty.app/api/runtime/4b54264a4d0449de871402b85f4d3751'
  }
}
const devUser = {
  id: 17,
  name: 'Boyd Hofman',
  email: 'bhofman@ilionx.com',
  countrycode: 'NL',
  csrf: 'Eo/9JLycJqHTTLQ9K7yZEQCH/zWukHtZlzBpal35qxM=',
  jwt: {
    accessExpiresAt: '2022-10-25T11:36:18Z',
    accessExpiresIn: 7200,
    isValid: true,
    jwtToken:
      'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJhcHBfdXVpZCI6ImYyNjY2MzMwMDVkNzRjOWJiM2NjYjQ4MzhhOGQyODA2IiwiYXVkIjoiSm9rZW4iLCJhdXRoX3Byb2ZpbGUiOiIwZmJlM2UyZTIwOTY0OTk0OWI4MTBjNjNmMWM0Mjk4MCIsImV4cCI6MTY2NjY5Nzc3OCwiaWF0IjoxNjY2NjkwNTc4LCJpc3MiOiJKb2tlbiIsImp0aSI6IjJzZ2tjZzE5bnU3YmxxaG42ODAwZ2tuMyIsImxvY2FsZSI6bnVsbCwibmJmIjoxNjY2NjkwNTc4LCJyb2xlcyI6WzJdLCJ1c2VyX2lkIjoxN30.CrLk80rLaLqE25IFSf_qFG0X4ApuZqYUFSTbBE1ucoK2bIsqDZ7zp-O9Od8kpYhcyIi4PmTBf2fsabnQsSsrRg',
    refreshExpiresAt: '2022-10-28T09:36:18Z',
    refreshExpiresIn: 259200,
    refreshToken:
      'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJKb2tlbiIsImV4cCI6MTY2Njk0OTc3OCwiaWF0IjoxNjY2NjkwNTc4LCJpc3MiOiJKb2tlbiIsImp0aSI6IjJzZ2tjZzE5cDA0NDNxaG42ODAwZ2tvMyIsIm5iZiI6MTY2NjY5MDU3OCwibm9uY2UiOiJ3azJ4LWZlWiIsInJlZnJlc2giOnRydWUsInJlZnJlc2hfaWQiOiJnSGJfOGhFM0xJUEhkWU9xX1FjNHNBZU5icGRxRmg0UCIsInVzZXJfaWQiOjE3fQ.irX_2fLKgNW3uqvDbmrlXEBSrWawTP6XkVfTkAUCHt_iYbooBserSc4jSdGakzQVIV78l4vW5cQIWiHfIwRLGg'
  },
  roles: ['Global admin']
}
const countrycode = 'NL'

const rightDrawerRoutes = ['Project', 'New project']
export default {
  apiUrl: bbUrl,
  devUser: devUser,
  countrycode: countrycode,
  env,
  graphUrl,
  rightDrawerRoutes
}
